import React from 'react';
// import PropTypes from 'prop-types';

const CalendarIcon = () => (
  <img
    src="/icons/solar_calendar-bold.png"
    alt=""
    aria-hidden
    width={24}
    height={24}
  />
);

CalendarIcon.propTypes = {
};

export default React.memo(CalendarIcon);
